export const contractVersion = "draft-2026-07-23";
export const isPolicyDecision = (value) => value === "allow" || value === "deny" || value === "not_applicable";
//# sourceMappingURL=index.js.map